import { FC } from 'react';
import { NavBarActiveKey, NavMenuItemType } from 'src/app.core/linkareer/constant/navBarMenuItems';
import SecondDepthNavBar from './SecondDepthNavBar';

interface IFNavBarHoverMenuProps {
  activeKey: NavBarActiveKey;
  menuItems: Array<NavMenuItemType>;
  isSelectedMainMenu: boolean;
}

const NavBarHoverMenu: FC<IFNavBarHoverMenuProps> = ({
  activeKey,
  menuItems,
  isSelectedMainMenu,
}) => {
  return (
    <SecondDepthNavBar
      className={isSelectedMainMenu ? '' : 'second-depth-nav-bar-hover'}
      menuItems={menuItems}
      activeKey={activeKey}
    />
  );
};

export default NavBarHoverMenu;
